import React, { useEffect, useState } from "react";
import { Routes, Route, Link, BrowserRouter } from "react-router-dom";

import Footer from "../layout/Footer";
import Header from "../layout/Header";

import { Componentes } from "../pages/Otro/Componentes";
import { Home } from "../pages/Vecino/Home";
import { VerSolicitud } from "../pages/Solicitud/VerSolicitud";
import { CrearSolicitud } from "../pages/Solicitud/CrearSolicitud";
import { CompletarPerfil } from "../pages/Vecino/CompletarPerfil";
import { EditarPerfil } from "../pages/Vecino/EditarPerfil";

export const DashboardRouter = () => {
  const [menuMobileState, setmenuMobileState] = useState(false);

  return (
    <div className="d-flex flex-column flex-root">
      <div className="page d-flex flex-row flex-column-fluid">
        <div
          className="wrapper d-flex flex-column flex-row-fluid"
          id="kt_wrapper"
        >
          <Header setmenuMobileState={setmenuMobileState} />

          <Routes>
            <Route path="/Home" element={<Home />} />
            <Route path="/VerSolicitud/:id_request_neighbor" element={<VerSolicitud />} /> 
            <Route path="/CrearSolicitud" element={<CrearSolicitud />} />
            <Route path="/CompletarPerfil" element={<CompletarPerfil />} />
            <Route path="/EditarPerfil" element={<EditarPerfil></EditarPerfil>} />
            <Route path="/Componentes" element={<Componentes />} />
            <Route path="/" element={<Home />} />
            <Route path="/*" element={<Home />} />
          </Routes>

          <Footer />
        </div>
      </div>
    </div>
  );
};
